export const errorFormatter = (error: Error | undefined): string => {
  return `${error?.name ?? ''} ${error?.message ?? ''}`.trim()
}
